import { useState, useEffect, useMemo } from 'react';
import "../../style/ScheduleCalendar/index.scss";
import { useAtom } from "jotai";
import { DarkModeState } from "../../Jotai/index";

const ONLINE_CAL_URL = "https://calendar.google.com/calendar/u/0?cid=Y181ZmNiYmFmNmFkNWEyNmNjYWM4MTVjMzFmMDcyODI0YzJmYTEzMWJiNjFlZDY3YWYwMWEyZGQ1YmFkYWYzMTBkQGdyb3VwLmNhbGVuZGFyLmdvb2dsZS5jb20";
const FM_CAL_URL = "https://calendar.google.com/calendar/u/0?cid=Y19kNjBiMjFlNTgzM2IzNjA1ZDc4MGQ4M2JjNGNhMzJkZWYwN2VkOWRmMTE4MDE4NDFhZjJkMDNmYTg0ODQxMDE0QGdyb3VwLmNhbGVuZGFyLmdvb2dsZS5jb20";

const toEmbedSrc = (calendarUrl, mode = "WEEK") => {
  try {
    const cid = new URL(calendarUrl).searchParams.get("cid");
    const calendarId = cid ? atob(cid) : "";
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "America/Los_Angeles";
    return `https://calendar.google.com/calendar/embed?src=${encodeURIComponent(
      calendarId
    )}&mode=${mode}&showPrint=0&showTabs=1&showCalendars=0&showTz=0&wkst=1&ctz=${encodeURIComponent(tz)}`;
  } catch {
    return "";
  }
};

const ScheduleCalendar = ({ id }) => {
  const [darkMode] = useAtom(DarkModeState);
  const [activeTab, setActiveTab] = useState("online"); // default to Online
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < 768);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const mode = isMobile ? "AGENDA" : "WEEK";
  const onlineSrc = useMemo(() => toEmbedSrc(ONLINE_CAL_URL, mode), [mode]);
  const fmSrc = useMemo(() => toEmbedSrc(FM_CAL_URL, mode), [mode]);

  return (
    <div id={id} className="ScheduleCalendar-container">
      <div className={darkMode ? "ScheduleCalendarCSS darkmode" : "ScheduleCalendarCSS"}>
        <div className={darkMode ? "ScheduleCalendar-title" : "ScheduleCalendar-title whitemode"}>
          Radio Schedule
        </div>

        <div className="ScheduleCalendarTabs">
          <button
            className={`tab ${activeTab === "online" ? "active" : ""}`}
            onClick={() => setActiveTab("online")}
          >
            Online
          </button>
          <button
            className={`tab ${activeTab === "fm" ? "active" : ""}`}
            onClick={() => setActiveTab("fm")}
          >
            FM
          </button>
        </div>

        <div className="ScheduleCalendarCSSMain">
          {activeTab === "online" ? (
            <iframe
              title="Online Radio Schedule"
              src={onlineSrc}
              className="calendar-embed"
              style={{ border: 0, overflow: "hidden" }}
              width="100%"
              height="800"
              loading="lazy"
            />
          ) : (
            <iframe
              title="FM Radio Schedule"
              src={fmSrc}
              className="calendar-embed"
              style={{ border: 0, overflow: "hidden" }}
              width="100%"
              height="800"
              loading="lazy"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ScheduleCalendar;